import { PAYMENT_STATUS } from "../constants"

// BookingTag color per payment status (upcoming-experience table)
export const PAYMENT_COLOR = {
  [PAYMENT_STATUS.paid]: "success",
  [PAYMENT_STATUS.partial]: "warning",
  [PAYMENT_STATUS.partial_refund]: "blue"
}

export const PAYMENT_LABEL = {
  [PAYMENT_STATUS.paid]: "Paid in Full",
  [PAYMENT_STATUS.partial]: "Balance Due",
  [PAYMENT_STATUS.partial_refund]: "Partial Refund"
}

// DollarSign stroke per BookingTag color — fixed hues that match the Legend.
// Not theme tokens: `colorInfo` is remapped to the brand color per theme (magenta in
// sportswoman), which would turn the blue "Partial Refund" dollar sign red/pink.
export const DOLLAR_STROKE = {
  success: "#45bf6b",
  warning: "#F98600",
  error: "#ef4444",
  blue: "#1d72f4"
}

// EditableTagCell: chips shown before the "+N more" overflow, and search debounce (ms)
export const VISIBLE_COUNT = 3
export const SEARCH_DELAY = 300
